import React, { useCallback, useMemo } from 'react';
import { FormGroup, Grid, makeStyles, createStyles } from '@material-ui/core';
import DropDownSelector from 'src/components/Inputs/DropDownSelector';
import FormControlLabel from './FormControlLabel';
const useStyles = makeStyles((theme) => createStyles({
    container: {
        width: 182,
        marginBottom: theme.spacing(2)
    },
    errorText: {
        color: '#a94442'
    }
}));
function FormSelect({ input, meta = { valid: true, submitFailed: false }, title = '', options = [], disabled = false, enableFiltering = true, isSingleSelect = false, mouseInKey = '', isRequired = false, errorMessage, direction = 'column', className = '', containerClass = '', ...selectProps }) {
    const classes = useStyles();
    const { value, name, onChange } = input;
    const { valid, submitFailed } = meta;
    const isValid = !submitFailed || valid;
    const isRow = direction === 'row';
    const selectedValues = useMemo(() => {
        if (!value)
            return [];
        if (Array.isArray(value))
            return value;
        return [value];
    }, [value]);
    const handleSelect = useCallback((val) => {
        if (isSingleSelect) {
            onChange(val[0]);
        }
        else {
            onChange(val);
        }
    }, [isSingleSelect, onChange]);
    return (React.createElement(Grid, { container: true, direction: direction, spacing: isRow ? 1 : 0, className: className },
        (title || (!isValid && errorMessage)) && (React.createElement(Grid, { container: true, spacing: 2, justifyContent: "space-between", wrap: "nowrap" },
            title && (React.createElement(Grid, { item: true },
                React.createElement(FormControlLabel, { title: title, mouseInKey: mouseInKey, isRequired: isRequired, isValid: isValid }))),
            !isValid && errorMessage && (React.createElement(Grid, { item: true },
                React.createElement("span", { className: classes.errorText }, errorMessage))))),
        React.createElement(Grid, { item: true, xs: isRow && title ? 6 : 'auto' },
            React.createElement(FormGroup, { className: `${classes.container} ${containerClass}` },
                React.createElement(DropDownSelector, { key: name, disabled: disabled || options.length === 0, listWidth: 350, isValid: isValid, options: options, filterEnabled: enableFiltering, isSingleSelect: isSingleSelect, values: selectedValues, onSelect: handleSelect, ...selectProps })))));
}
export default FormSelect;
